import {Box, Button, Grid, IconButton, Stack} from "@mui/material";
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';
import ZoomInMapOutlinedIcon from '@mui/icons-material/ZoomInMapOutlined';
import {useAppContext} from "@/contexts/AppContext.tsx";
import {grey} from "@mui/material/colors";
import React from "react";

export interface RightAttachedSidebarProps {
    children: React.ReactNode;
    title?: string
    resize?: boolean
}

export default function MainAttachedSidebar({children, title, resize}: RightAttachedSidebarProps) {
    const {modalWidth, setModalWidth} = useAppContext();

    return (
        <>
            <Grid item sx={{
                width: modalWidth,
                boxShadow: '0 1px 1px 0 rgba(0, 28, 36, .3), 1px 1px 1px 0 rgba(0, 28, 36, .15), -1px 1px 1px 0 rgba(0, 28, 36, .15)'
            }}>
                {title && (
                    <Box sx={{height: 50, p: 1, borderBottom: `1px solid ${grey[300]}`}}>
                        <Stack direction="row" justifyContent="space-between">
                            <Button variant="text" sx={{fontSize: 13, fontWeight: 500, mr: 1}}>
                                {title}
                            </Button>
                            {resize && (
                                <IconButton onClick={() => setModalWidth(modalWidth === 380 ? 760 : 380)}
                                            aria-label="delete">
                                    {modalWidth === 380 ? <ZoomOutMapOutlinedIcon sx={{fontSize: 20}}/> :
                                        <ZoomInMapOutlinedIcon sx={{fontSize: 20}}/>}
                                </IconButton>
                            )}
                        </Stack>
                    </Box>
                )}
                {children}
            </Grid>
        </>
    )
}